const Quote = () => (
  <>
    <div className="text-white py-3 px-5">
      <h4 className="text-white">
        Mathematics is not about numbers, equations, computations, or
        algorithms: it is about understanding. -Willian Paul Thurston
      </h4>
    </div>
  </>
);

export default Quote;
